// extracted by mini-css-extract-plugin
export default {"buttonWrap":"detail-icon_buttonWrap__qXKtx","btn":"detail-icon_btn__37C3L","menuWrap":"detail-icon_menuWrap__abHjC","menuItemWrap":"detail-icon_menuItemWrap__rNPUA"};